export default __webpack_public_path__ + "static/media/cover-autofollow.5f275bd6.png";